import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material/styles';

import { useRegisterPageContainerError } from '../../../components/layout/page-container/page-container-error-handler';
import { useNavigationStack } from '../../../context/NavigationStackContext';
import { useRestrictions } from '../../../hooks/use-restrictions';
import { useGetUserProgramCollections } from '../../../redux/api/programsAPI';
import { Paths } from '../../../shared/paths';
import { orderBy } from '../../../utils/collections/array-utils';
import ProgramCollectionList from '../shared/program-collection-list/ProgramCollectionList';
import { useStyles } from './ProgramCollections.styles';

interface ProgramCollectionsProps {
  setPlanDialogOpen: (open: boolean) => void;
}

const ProgramCollections = ({ setPlanDialogOpen }: ProgramCollectionsProps) => {
  const { t, i18n } = useTranslation();
  const { navigate } = useNavigationStack();
  const {
    data: programCollections,
    isLoading,
    isUninitialized,
    error,
    refetch,
  } = useGetUserProgramCollections();

  const userProgramCollections = programCollections
    ? orderBy(programCollections, 'title')
    : null;

  const theme = useTheme();

  const { classes } = useStyles(theme);
  const isDataLoading = isLoading && !isUninitialized;
  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);
  useRegisterPageContainerError({
    errors: error ? [error] : [],
    isLoading: isDataLoading,
    hasData: Boolean(userProgramCollections?.length),
    onRetry: handleRetry,
  });
  const { isShowAddButton, isShowPlanDialogOnClick } = useRestrictions();

  function itemClick(program) {
    navigate(Paths.programs.toViewCollectionDetailsId(program.id));
  }

  function onAddClick() {
    if (isShowPlanDialogOnClick?.programCollection) {
      setPlanDialogOpen(true);
    } else {
      navigate(Paths.programs.toNewCollection);
    }
  }

  return (
    <ProgramCollectionList
      programCollections={userProgramCollections}
      onItemClick={itemClick}
      onAddClick={isShowAddButton?.programCollection && onAddClick}
      isLoading={isDataLoading}
    />
  );
};

export default ProgramCollections;
